module.exports = __webpack_public_path__ + "static/media/avatar_27.467bbb38.svg";